import NpdResult from '@/pages/NpdResult';

export default function NpdCorrect() {
  return <NpdResult variant="correct" />;
}
